import { Status } from '../models/AuthCommonModels';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAuthCommonStore: any = defineStore('authCommonStore', () => {
  const status = ref<Status>(sessionStorage.getItem('auth.status') != null ? JSON.parse(sessionStorage.getItem('auth.status')!) : new Status());

  function setStatus(newStatus: Status) {
    status.value = newStatus;
    sessionStorage.setItem('auth.status', JSON.stringify(status.value));
  }

  return {
    status,
    setStatus,
  };
});
